import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/betzone')({
  component: () => (
    <RoutePlaceholder icon="betzone" title="Betzone" description="Curated bet builder offers." />
  ),
});
